module.exports = __webpack_public_path__ + "img/background-quienes-somos.929b8ff8.png";